import React, { useState } from 'react';
import Button from '../../../shared/components/Button/Button';
import formatBRL from '../../../shared/utils/formatBRL';
import './PaymentLinkResult.css';

/**
 * Resumo do link recém-gerado — url pronta pra copiar/enviar ao cliente.
 */
const PaymentLinkResult = ({ result }) => {
  const [copied, setCopied] = useState(false);

  if (!result) return null;

  const handleCopy = () => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(result.url);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="payment-link-result">
      <p className="payment-link-result__title">Link gerado com sucesso!</p>
      <div className="payment-link-result__url-row">
        <input type="text" readOnly value={result.url} className="form-control" />
        <Button variant="primary" onClick={handleCopy}>
          {copied ? 'Copiado!' : 'Copiar'}
        </Button>
      </div>
      <p className="payment-link-result__meta">
        Valor: {formatBRL((result.amount || 0) / 100)} — Status: {result.status}
      </p>
    </div>
  );
};

export default PaymentLinkResult;
